import { useEffect, useState } from 'react';
import apiNet from '../../../../newApi/apiNet.ts';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { PulseLoader } from '../../../loaders/PulseLoader.tsx';
import { useAuth } from '../../../../hooks/useAuth.tsx';
import { useAppSelector } from '../../../../stores/store.ts';
import { selectCurrentUser } from '../../../auth/authSelectors.ts';

const AccountManagementBannersList = () => {
    const { user } = useAuth();
    const [banners, setBanners] = useState<{ id: string, title: string }[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const _currentUser = useAppSelector(selectCurrentUser);
    useEffect(() => {
        if (user || _currentUser) {
            (async () => {
                try {
                    setIsLoading(true);
                    const response = await apiNet.getPromotionBannersAll();
                    setBanners(response.data);
                    setIsLoading(false);
                } catch (e) {

                }
            })();
        }
    }, [user, _currentUser]);

    return (
        <div className="max-w-lg">
            <h1 className="text-3xl">Lista banerów</h1>
            <div className="h-0.5 w-28 bg-sky-500 my-4 rounded-r-full" />
            <div className={'flex items-center space-x-3 my-4 text-blue-500 bg-blue-50 p-3 rounded-md'}>
                <InformationCircleIcon className={'w-5 h-5 shrink-0'} />
                <p className={'text-sm'}>Sortowanie według daty zakończenia</p>
            </div>
            <div className="space-y-3 flex flex-col bg rounded-3xl">
                {isLoading &&
                    <PulseLoader description="Ładowanie ..." />
                }
                {!isLoading && banners.length === 0 &&
                    <div
                        className={`relative flex justify-center items-center bg-neutral-900 rounded-xl p-2 px-2 border-neutral-600 text-neutral-300 transition`}>
                        <p>Brak elementów</p>
                    </div>
                }
                {!isLoading && banners.length !== 0 &&
                    <ul className="bg-neutral-950 rounded-lg mt-2 overflow-hidden text-neutral-200">
                        {banners.map((banner, index) =>
                            <li key={banner.id}
                                className={`relative flex justify-between items-center hover:bg-neutral-700 p-2 px-2 border-neutral-600 hover:text-white transition ${index < banners.length - 1 ? 'border-b' : ''}`}>
                                <p>{banner.title}</p>
                                <ChevronRightIcon className="w-7 h-7" />
                                <Link className="absolute inset-0" to={`/ustawienia/banery/${banner.id}`} />
                            </li>,
                        )}
                    </ul>
                }
            </div>
        </div>
    );
};

export default AccountManagementBannersList;